import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface ResourceAssistantState {
  filterByProposal: boolean
}

interface UpdatePayload {
  filterByProposal: boolean
}

const initialState: ResourceAssistantState = {
  filterByProposal: true
};

const resourceAssistantSlice = createSlice({
  name: 'resourceAssistant',
  initialState,
  reducers: {
    updateResourceAssistantState (state, action: PayloadAction<UpdatePayload>) {
      return {
        ...state,
        ...action.payload
      };
    },
    resetState () {
      return initialState;
    }
  }
});

export const { updateResourceAssistantState, resetState } = resourceAssistantSlice.actions;
export default resourceAssistantSlice.reducer;
